import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertService } from 'src/app/_services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ColDef, Column, ColumnApi, GridApi, GridOptions, GridReadyEvent, ITooltipParams } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { PaymentGatewayService } from '../payment-gateway-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-merchant-account-edit',
  templateUrl: './merchant-account-edit.component.html',
  styleUrls: ['./merchant-account-edit.component.scss']
})
export class MerchantAccountEditComponent implements OnInit {

  
  payId: string;

  activePanel: string = '';
  @ViewChild('acc', { static: true }) accordion: any;
  submitted: boolean = false;

  accordions: any = [
    {
      title: 'Action',
      formControls: [
        { name: 'Status', controlName: 'userStatus', type: 'select', data: [], disabled: false },
        { name: 'Processing Mode', controlName: 'modeType', type: 'select', data: [], disabled: false },
        { name: 'Comments(Maximum 200 Characters)', controlName: 'comments', type: 'textarea', disabled: false }
      ]
    },
    {
      title: 'Merchant Details',
      formControls: [
        { name: 'Pay ID', controlName: 'payId', type: 'text', disabled: true },
        { name: 'Business Name', controlName: 'businessName', type: 'text', disabled: true },
        { name: 'First Name', controlName: 'firstName', type: 'text', disabled: false },
        { name: 'Reseller Id', controlName: 'resellerId', type: 'number', disabled: false },
        { name: 'Last Name', controlName: 'lastName', type: 'text', disabled: false },
        { name: 'Industry Category', controlName: 'industryCategory', type: 'select', data: [], disabled: false },
        { name: 'Company Name', controlName: 'companyName', type: 'text', disabled: false },
        { name: 'Industry Sub Category', controlName: 'industrySubCategory', type: 'text', disabled: true },
        { name: 'Registration Date', controlName: 'registrationDate', type: 'text', disabled: true },
        { name: 'Email ID', controlName: 'emailId', type: 'text', disabled: true },
        { name: 'Activation Date', controlName: 'activationDate', type: 'text', disabled: true },
        { name: 'Request URL', controlName: 'requestURL', type: 'text', disabled: true },
        { name: 'User Group', controlName: 'userGroupId', type: 'select', data: [], disabled: true },
        { name: 'Salt', controlName: 'salt', type: 'text', disabled: true },
        { name: 'Role', controlName: 'roleId', type: 'select', data: [], disabled: false },
        { name: 'Merchant Hosted Encryption Key', controlName: 'merchantHostedEncryptionKey', type: 'text', disabled: true },
        { name: 'Merchant Static Encryption Key', controlName: 'merchantStaticEncryptionKey', type: 'text', disabled: true },
        { name: 'Terms & Condition applicable for Payment & Invoice', controlName: 'tncStatus', type: 'checkbox', disabled: false },
        { name: 'E-KYC Flag', controlName: 'ekycFlag', type: 'checkbox', disabled: false },
        { name: 'Enable SI', controlName: 'siFlag', type: 'checkbox', disabled: false },
        { name: 'Charges Flag', controlName: 'chargesFlag', type: 'checkbox', disabled: false },
        { name: 'Daily Email Flag', controlName: 'dailyEmailFlag', type: 'checkbox', disabled: false },
      ]
    },
    {
      title: 'Contact Details',
      formControls: [
        { name: 'Mobile', controlName: 'mobile', type: 'text', disabled: false },
        { name: 'Address', controlName: 'address', type: 'text', disabled: false },
        { name: 'State', controlName: 'state', type: 'select', data: [], disabled: false, required: true },
        { name: 'City', controlName: 'city', type: 'text', disabled: false },
        { name: 'Postal Code', controlName: 'postalCode', type: 'number', disabled: false },
        { name: 'Country', controlName: 'country', type: 'select', data: [], disabled: false }
      ]
    },
    {
      title: 'Notification Setting',
      formControls: [
        { name: 'Active SMS Service', controlName: 'transactionSmsFlag', type: 'checkbox', disabled: false },
        { name: 'Customer Authentication Emailer', controlName: 'transactionAuthenticationEmailFlag', type: 'checkbox', disabled: false },
        { name: 'Customer Transaction Emailer', controlName: 'transactionCustomerEmailFlag', type: 'checkbox', disabled: false },
        { name: 'Customer Refund Emailer', controlName: 'refundTransactionCustomerEmailFlag', type: 'checkbox', disabled: false },
        { name: 'Merchant Transaction Emailer', controlName: 'transactionEmailerFlag', type: 'checkbox', disabled: false },
        { name: 'Merchant Refund Emailer', controlName: 'refundTransactionMerchantEmailFlag', type: 'checkbox', disabled: false },
        { name: 'Transaction Failed Alert', controlName: 'transactionFailedAlertFlag', type: 'checkbox', disabled: false },
        { name: 'Transaction Failed Alert', controlName: 'transactionFailedAlertFlag', type: 'checkbox', disabled: false },
        { name: 'Merchant Transaction Email', controlName: 'transactionEmailId', type: 'text', disabled: false },
        { name: 'Merchant Transaction SMS', controlName: 'transactionSms', type: 'text', disabled: false },
      ]
    },
    {
      title: 'Reporting Setting',
      formControls: [
        { name: 'Email ID 1', controlName: 'reportEmailId1', type: 'text', disabled: false },
        { name: 'Email ID 2', controlName: 'reportEmailId2', type: 'text', disabled: false },
        { name: 'Email ID 3', controlName: 'reportEmailId3', type: 'text', disabled: false },
        { name: 'Email ID 4', controlName: 'reportEmailId4', type: 'text', disabled: false },
        { name: 'Email ID 5', controlName: 'reportEmailId5', type: 'text', disabled: false },
        { name: 'Sale Captured Report', controlName: 'saleCaptured', type: 'checkbox', disabled: false },
        { name: 'Refund Captured Report', controlName: 'refundCaptured', type: 'checkbox', disabled: false },
        { name: 'Settled Report', controlName: 'settledReport', type: 'checkbox', disabled: false },
        { name: 'Frequency', controlName: 'frequency', type: 'select', data: [], disabled: false },
        // { name: 'Start Time', controlName: 'startTime', type: 'select', data:[], disabled: false },
        // { name: 'End Time', controlName: 'endTime', type: 'select', data:[], disabled: false },
        // { name: 'Hourly Frequency', controlName: 'hourlyFrequency', type: 'select', data:[], disabled: false },
      ]
    },
    {
      title: 'Transaction Settings',
      formControls: [
        { name: 'Default Reporting Currency', controlName: 'currency', type: 'select', data: [], disabled: false },
        { name: 'Payment Message Slab', controlName: 'paymentMessageSlab', type: 'select', disabled: false },
        { name: 'Merchant	Hosted Page', controlName: 'merchantHostedFlag', type: 'checkbox', disabled: false },
        { name: 'Merchant	S2S Flag', controlName: 'merchantS2SFlag', type: 'checkbox', disabled: false },
        { name: 'Iframe	Payment', controlName: 'iframePaymentFlag', type: 'checkbox', disabled: false },
        { name: 'Retry Transaction', controlName: 'retryTransactionCustomeFlag', type: 'checkbox', disabled: false },
        { name: 'Number of Retry', controlName: 'attemptTrasacation', type: 'select', data: [], disabled: false },
        { name: 'Express Pay', controlName: 'expressPayFlag', type: 'checkbox', disabled: false },
        { name: 'Card	Save Param', controlName: 'cardSaveParam', type: 'select', data: [], disabled: false },
        { name: 'Skip	OrderId for Refund', controlName: 'skipOrderIdForRefund', type: 'checkbox', disabled: false },
        { name: 'Allow Duplicate Sale', controlName: 'allowSaleDuplicate', type: 'checkbox', disabled: false },
        { name: 'Allow Duplicate Refund', controlName: 'allowRefundDuplicate', type: 'checkbox', disabled: false },
        { name: 'Allow Sale In Refund', controlName: 'allowSaleInRefund', type: 'checkbox', disabled: false },
        { name: 'Allow Refund In Sale', controlName: 'allowRefundInSale', type: 'checkbox', disabled: false },
        { name: 'Liability Hold (In %)', controlName: 'liabilityHold', type: 'text', disabled: false },
        { name: 'Auto Refund', controlName: 'autoFlag', type: 'checkbox', disabled: false },
        { name: 'Extra Refund Amount', controlName: 'extraRefundLimit', type: 'text', disabled: false },
        { name: 'Enable	Auto Refund Post Settlement', controlName: 'enableAutoRefundPostSettlement', type: 'checkbox', disabled: false },
        { name: 'Enable	White Label URL', controlName: 'enableWhiteLabelUrl', type: 'checkbox', disabled: false },
        { name: 'Domain	Name', controlName: 'whiteLabelUrl', type: 'text', disabled: false },
        { name: 'Enable	Notification API', controlName: 'notificationApiEnableFlag', type: 'checkbox', disabled: false },
        { name: 'Enable	TPV', controlName: 'tpv', type: 'checkbox', disabled: false },
        { name: 'Enable	WebStore API', controlName: 'webStoreApiEnableFlag', type: 'checkbox', disabled: false },
        { name: 'Payment Link', controlName: 'paymentLink', type: 'text', disabled: true },
      ]
    },
    {
      title: 'Naming Convention',
      formControls: [
        { name: 'Settlement', controlName: 'settlementNamingConvention', type: 'text', disabled: false },
        { name: 'Refund	Validation', controlName: 'refundValidationNamingConvention', type: 'text', disabled: false },
      ]
    },
    {
      title: 'Bank Details',
      formControls: [
        { name: 'Split Payment', controlName: 'splitPaymentStatus', type: 'checkbox', disabled: true, },
        { name: 'Bank Name', controlName: 'bankName', type: 'text', disabled: true, required: true },
        { name: 'AC. Holder Name', controlName: 'accHolderName', type: 'text', disabled: true, required: true },
        { name: 'Account No./IBAN', controlName: 'ifscCode', type: 'text', disabled: true, required: true },
        { name: 'Bank Currency', controlName: 'currency', type: 'text', disabled: true },
        // { name: 'PAN Card', controlName: 'panCard', type: 'text', disabled: false },
        { name: 'Branch Name', controlName: 'branchName', type: 'text', disabled: true, required: true },
        // { name: 'Account No.', controlName: 'accountNo', type: 'text', disabled: false, required: true },
      ]
    },
    {
      title: 'Business Details',
      formControls: [
        { name: 'Organisation	Type', controlName: 'organisationType', type: 'select', data: [], disabled: false },
        { name: 'Website URL', controlName: 'website', type: 'text', disabled: false },
        { name: 'Multicurrency Payments Required?', controlName: 'multiCurrency', type: 'select', data: [], disabled: false },
        { name: 'Business Model', controlName: 'businessModel', type: 'text', disabled: false },
        { name: 'Operation Address', controlName: 'operationAddress', type: 'text', disabled: false },
        { name: 'Operation Address State', controlName: 'operationState', type: 'select', data: [], disabled: false },
        { name: 'Operation Address City', controlName: 'operationCity', type: 'text', disabled: false },
        { name: 'Operation Address Pincode', controlName: 'operationPostalCode', type: 'number', disabled: false },
        { name: 'Date of Establishment', controlName: 'dateOfEstablishment', type: 'text', disabled: false },
        { name: 'CIN', controlName: 'cin', type: 'text', disabled: false },
        { name: 'PAN', controlName: 'pan', type: 'text', disabled: false },
        { name: 'Name on PAN Card', controlName: 'panName', type: 'text', disabled: false },
        { name: 'Expected number of transaction', controlName: 'noOfTransactions', type: 'number', disabled: false },
        { name: 'Expected amount of transaction', controlName: 'amountOfTransactions', type: 'number', disabled: false },
        { name: 'Merchant GST No.', controlName: 'merchantGstNo', type: 'text', disabled: false },
      ]
    },
  ]

  orgType: any = [
    { key: 'Government', value: 'Government' },
    { key: 'Proprietship', value: 'Proprietship' },
    { key: 'Individual', value: 'Individual' },
    { key: 'Partnership', value: 'Partnership' },
    { key: 'Private Limited', value: 'Private Limited' },
    { key: 'Public Limited', value: 'Public Limited' },
    { key: 'LLP', value: 'LLP' },
    { key: 'NGO', value: 'NGO' },
    { key: 'Educational Institutes', value: 'Educational Institutes' },
    { key: 'Trust', value: 'Trust' },
    { key: 'Society', value: 'Society' },
    { key: 'Freelancer', value: 'Freelancer' }
  ];

  merchantForm!: FormGroup;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  rowData: any = [];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 160,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };
  gridOptions: GridOptions;

  public columnDefs: ColDef[] = [
    {
      field: 'productId', tooltipField: 'productId', headerName: 'Product ID', hide: false, valueFormatter: (params: any) => {
        return params.value ? params.value : '--';
      }
    },
    {
      field: 'accountNumber', headerName: 'Account Number', hide: false, tooltipValueGetter: (params: ITooltipParams) => {
        return params.value
      }, valueFormatter: (params: any) => {
        return params.value ? params.value : '--';
      }
    },
    {
      field: 'ifscCode', tooltipField: 'ifscCode', hide: false, headerName: 'IFSC Code', valueFormatter: (params: any) => {
        return params.value ? params.value : '--';
      }
    },
    {
      field: 'bankName', tooltipField: 'bankName', hide: false, headerName: 'Bank Name', valueFormatter: (params: any) => {
        return params.value ? params.value : '--';
      }
    },
    {
      field: 'accountHolderName', headerName: 'Holder Name', hide: false, tooltipValueGetter: (params: ITooltipParams) => {
        return params.value
      }, valueFormatter: (params: any) => {
        return params.value ? params.value : '--';
      }
    },
    {
      field: 'actions', headerName: 'Actions', width: 30, cellRenderer: BtnCellRenderer, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.deleteSplitPayment(param.data.id);
          },
          buttonText: 'Delete',
          buttonClass: 'btn-sm btn-sm-ag-renderer'
        },
      ]
    }
  ];
  resellerList: any = [];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide && col.field !== 'actions'))];

  constructor(private alertService: AlertService, private _MS: PaymentGatewayService, private routes: ActivatedRoute, private _FB: FormBuilder) { }

  ngOnInit(): void {
    this.getUserStatus();
    this.getModType();
    this.getCountries();
    this.routes.params.subscribe(
      (data: any) => {
        if (data && data.payId) {
          this.payId = data.payId;
          this.getEditDetails();
        }
      }
    )
    this.merchantForm = this._FB.group({});

    this.merchantForm.get('currency')?.patchValue("asdf")
    console.log("merchant form : ",this.merchantForm)
  }

  countries: any = [];
  states: any = [];
  getCountries() {
    this.states = [];
    this._MS.getCountries().subscribe({
      next: (data: any) => {
        if (data && data.length) {
          this.countries = data.map((_: any) => {
            return { key: _.name, value: _.name, ..._ };
          });
        } else {
          this.countries = [];
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        });
      }
    });
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    this.isSplitPayment ? this.fetchSplitPayment() : this.rowData = [];
  }

  getStates(eve: any) {
    this._MS.getStates(eve).subscribe({
      next: (data: any) => {
        if (data && data.length) {
          this.states = data.map((_: any) => {
            return { key: _.name, value: _.name, ..._ };
          });
        } else {
          this.states = [];
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        });
      }
    });
  }

  businessTypes: any = [];
  userGroups: any = [];
  currencyList: any = [];
  roles: any = [];
  merchantDetails: any;
  newUser: any;
  getEditDetails() {
    let email: any = localStorage.getItem('email');
    let obj = {
      payId: this.payId,
      loggedUserEmailId: email
    }
    this._MS.getEditDetails(obj).subscribe(
      {
        next: (data: any) => {
          console.log(data);
          if (data && data.status === "OK") {

            this._MS.getStaticEncKey(this.payId).subscribe((response:any)=>{
              console.log(response.response.data)
              this.merchantForm.addControl('merchantStaticEncryptionKey', new FormControl({ value: response?.response?.data ? response?.response?.data : '', disabled: true }));
            })
            data.payload.user.reportEmailId1 = data.payload.user.reportEmailId1 ? data.payload.user.reportEmailId1 : '';
            data.payload.user.reportEmailId2 = data.payload.user.reportEmailId2 ? data.payload.user.reportEmailId2 : '';
            data.payload.user.reportEmailId3 = data.payload.user.reportEmailId3 ? data.payload.user.reportEmailId3 : '';
            data.payload.user.reportEmailId4 = data.payload.user.reportEmailId4 ? data.payload.user.reportEmailId4 : '';
            data.payload.user.reportEmailId5 = data.payload.user.reportEmailId5 ? data.payload.user.reportEmailId5 : '';
            data.payload.user.whiteLabelUrl = data.payload.user.whiteLabelUrl ? data.payload.user.whiteLabelUrl : '';
            let obj1 = data.payload.user;
            this.newUser = data.payload.user;
            obj1 = { ...obj1, merchantHostedEncryptionKey: data.payload.merchantHostedEncryptionKey, notificationApiEnableFlag: data.payload.notificationApiEnableFlag, salt: data.payload.salt, requestURL: data.payload.requestURL, userGroupId: data.payload.userGroupId.toString(), roleId: data.payload.roleId.toString() };
            obj1.tncStatus ? this.createTncCotrols() : '';
            obj1.notificationApiEnableFlag ? this.createNotificationAPI() : '';
            this.merchantDetails = obj1;
            console.log("merchantDetails : ",obj1)
            this.getStates(this.merchantDetails.country);
            this.businessTypes = Object.keys(data.payload.industryTypesList).map((_: any) => {
              return { key: _, value: data.payload.industryTypesList[_] }
            });
            this.userGroups = data.payload.userGroups.map((_: any) => {
              return { key: _.id, value: _.group, ..._ }
            });
            this.roles = data.payload.roleList.map((_: any) => {
              return { key: _.id, value: _.roleName, ..._ }
            });
            this.currencyList = Object.keys(data.payload.currencyMap).map((_: any) => {
              return { key: _, value: data.payload.currencyMap[_] }
            });
            setTimeout(() => {
              this.accordions.map((_: any) => {
                _.formControls.map((__: any) => {
                  __.type === 'select' ? __.data = this.getData(__) : '';
                  let controlName = (_.title === 'Contact Details' || _.title === 'Bank Details') ? new FormControl({ value: __.type === 'select' ? null : '', disabled: __.disabled }, ((__.controlName === 'state' || _.title === 'Bank Details') && __.required) ? Validators.required : null) : new FormControl({ value: __.type === 'select' ? null : '', disabled: __.disabled })
                  this.merchantForm.addControl(__.controlName, controlName);
                })
              });
              this.merchantDetails && this.merchantDetails.splitPaymentStatus ? this.isSplitPayment = this.merchantDetails.splitPaymentStatus : null;
              if (this.isSplitPayment) {
                let arr = [{ name: 'Product ID', controlName: 'productId', type: 'text', disabled: false, required: true }];
                this.accordions[7].formControls.splice(8, 0, ...arr);
                this.merchantForm.addControl('productId', new FormControl({ value: this.merchantDetails.productId ? this.merchantDetails.productId : '', disabled: false }, Validators.required));
              } else {
                this.merchantForm.removeControl('productId');
                this.accordions[7].formControls = this.accordions[7].formControls.filter((control: any) => control.controlName !== 'productId');
              }
              if (this.merchantDetails.frequency === 'HOURLY') {
                this.showTimeFields(true);
              }

              // this.merchantDetails && this.merchantDetails.bankVerificationStatus ? this.isValidate = this.merchantDetails.bankVerificationStatus : null;
              this.merchantForm.patchValue(this.merchantDetails);
              this.merchantForm.patchValue({
                currency: environment.defaultCurrency
              });
              this.merchantForm.get('currency')?.disable();
            }, 1000);
          } else {
            this.alertService.toastWarringMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || 'Something went wrong!',
            })
          }
        },
        error: err => {
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          })
        }
      }
    )
  }

  createTncCotrols() {
    let arr = [{ name: 'Terms & Condition for Payment Page', controlName: 'payText', type: 'textarea', disabled: false }, { name: 'Terms & Condition for Invoice', controlName: 'invoiceText', type: 'textarea', disabled: false }];
    this.accordions[1].formControls.splice(16, 0, ...arr);
  }

  createNotificationAPI() {
    let arr = [{ name: 'API URL', controlName: 'notificaionApi', type: 'text', disabled: false }];
    this.accordions[5].formControls.splice(21, 0, ...arr);
  }

  changeTnc(eve: any) {
    let arr = [{ name: 'Terms & Condition for Payment Page', controlName: 'payText', type: 'textarea', disabled: false }, { name: 'Terms & Condition for Invoice', controlName: 'invoiceText', type: 'textarea', disabled: false }];
    if (eve.target.checked) {
      this.createTncCotrols();
      this.merchantForm.addControl('payText', new FormControl({ value: this.merchantDetails.payText ? this.merchantDetails.payText : '', disabled: false }));
      this.merchantForm.addControl('invoiceText', new FormControl({ value: this.merchantDetails.invoiceText ? this.merchantDetails.invoiceText : '', disabled: false }));
    } else {
      arr.map((_: any) => {
        this.removeFormControlsByNames(_.controlName)
      })
    }
  }

  changeAuto(eve: any) {
    let arr = [{ name: 'Timer for AutoRefund (HH:MM)', controlName: 'autoMin', type: 'text', disabled: false }];
    if (eve.target.checked) {
      this.accordions[5].formControls.splice(16, 0, ...arr);
      this.merchantForm.addControl('autoMin', new FormControl({ value: this.merchantDetails.autoMin ? this.merchantDetails.autoMin : '', disabled: true }));
    } else {
      this.merchantForm.removeControl('autoMin');
      this.accordions[5].formControls = this.accordions[5].formControls.filter((control: any) => control.controlName !== 'autoMin');
    }
  }

  changeNotificationFlag(eve: any) {
    let arr = [{ name: 'API URL', controlName: 'notificaionApi', type: 'text', disabled: false }];
    if (eve.target.checked) {
      this.accordions[5].formControls.splice(21, 0, ...arr);
      this.merchantForm.addControl('notificaionApi', new FormControl({ value: this.merchantDetails.notificaionApi ? this.merchantDetails.notificaionApi : '', disabled: false }));
    } else {
      this.merchantForm.removeControl('notificaionApi');
      this.accordions[5].formControls = this.accordions[5].formControls.filter((control: any) => control.controlName !== 'notificaionApi');
    }
  }

  isSplitPayment: boolean = false;
  changeSplitPayment(eve: any) {
    this.isSplitPayment = eve.target.checked;
    let arr = [{ name: 'Product ID', controlName: 'productId', type: 'text', disabled: false, required: true }];
    if (eve.target.checked) {
      this.accordions[7].formControls.splice(8, 0, ...arr);
      this.merchantForm.addControl('productId', new FormControl({ value: this.merchantDetails.productId ? this.merchantDetails.productId : '', disabled: false }, Validators.required));
    } else {
      this.merchantForm.removeControl('productId');
      this.accordions[7].formControls = this.accordions[7].formControls.filter((control: any) => control.controlName !== 'productId');
    }
  }

  removeFormControlsByNames(controlNames: string) {
    if (controlNames) {
      this.merchantForm.removeControl(controlNames);
    }
    this.accordions[1].formControls = this.accordions[1].formControls.filter((control: any) => control.controlName !== controlNames);
  }

  getData(control: any) {
    switch (control.controlName) {
      case 'organisationType':
        return control.data = this.orgType;
      case 'userStatus':
        return control.data = this.statusList;
      case 'modeType':
        return control.data = this.modTypeList;
      case 'multiCurrency':
        return control.data = [{ key: 'Yes', value: 'Yes' }, { key: 'No', value: 'No' }];
      case 'industryCategory':
        return control.data = this.businessTypes;
      case 'userGroupId':
        return control.data = this.userGroups;
      case 'roleId':
        return control.data = this.roles;
      case 'country':
        return control.data = this.countries;
      case 'state':
        return control.data = this.states;
      case 'operationState':
        return control.data = this.states;
      case 'paymentMessageSlab':
        return control.data = [{ key: 0, value: 0 }, { key: 1, value: 1 }, { key: 2, value: 2 }, { key: 3, value: 3 }, { key: 4, value: 4 }, { key: 5, value: 5 }];
      case 'currency':
        return control.data = this.currencyList;
      case 'attemptTrasacation':
        return control.data = [{ key: 1, value: 1 }, { key: 2, value: 2 }, { key: 3, value: 3 }, { key: 4, value: 4 }, { key: 5, value: 5 }];
      case 'cardSaveParam':
        return control.data = [{ key: "CUST_EMAIL", value: "CUST_EMAIL" }, { key: "CUST_ID", value: "CUST_ID" }, { key: "CUST_PHONE", value: "CUST_PHONE" }, { key: "MONTHLY", value: "MONTHLY" }];
      case 'frequency':
        return control.data = [{ key: "HOURLY", value: "HOURLY" }, { key: "DAILY", value: "DAILY" }, { key: "WEEKLY", value: "WEEKLY" }, { key: "MONTHLY", value: "MONTHLY" }];
      default:
        return control.data = []; // Default case if none match
    }
  }

  onChangeSelect(formName: any, value: any) {
    if (formName == 'frequency') {
      if (value === 'HOURLY') {
        this.showTimeFields(true);
      } else {
        this.showTimeFields(false);
      }
    }
  }

  removeFormControlsByReporting(controlNames: string) {
    if (controlNames) {
      this.merchantForm.removeControl(controlNames);
    }
    this.accordions[4].formControls = this.accordions[4].formControls.filter((control: any) => control.controlName !== controlNames);
  }

  showTimeFields(show: boolean) {
    let arr = [
      {
        name: 'Start Time', controlName: 'startTime', type: 'select', data: [
          { 'key': '00:00:00', 'value': '00:00:00 AM' },
          { 'key': '01:00:00', 'value': '01:00:00 AM' },
          { 'key': '02:00:00', 'value': '02:00:00 AM' },
          { 'key': '03:00:00', 'value': '03:00:00 AM' },
          { 'key': '04:00:00', 'value': '04:00:00 AM' },
          { 'key': '05:00:00', 'value': '05:00:00 AM' },
          { 'key': '06:00:00', 'value': '06:00:00 AM' },
          { 'key': '07:00:00', 'value': '07:00:00 AM' },
          { 'key': '08:00:00', 'value': '08:00:00 AM' },
          { 'key': '09:00:00', 'value': '09:00:00 AM' },
          { 'key': '10:00:00', 'value': '10:00:00 AM' },
          { 'key': '11:00:00', 'value': '11:00:00 AM' },
          { 'key': '12:00:00', 'value': '12:00:00 PM' },
          { 'key': '13:00:00', 'value': '01:00:00 PM' },
          { 'key': '14:00:00', 'value': '02:00:00 PM' },
          { 'key': '15:00:00', 'value': '03:00:00 PM' },
          { 'key': '16:00:00', 'value': '04:00:00 PM' },
          { 'key': '17:00:00', 'value': '05:00:00 PM' },
          { 'key': '18:00:00', 'value': '06:00:00 PM' },
          { 'key': '19:00:00', 'value': '07:00:00 PM' },
          { 'key': '20:00:00', 'value': '08:00:00 PM' },
          { 'key': '21:00:00', 'value': '09:00:00 PM' },
          { 'key': '22:00:00', 'value': '10:00:00 PM' },
          { 'key': '23:00:00', 'value': '11:00:00 PM' }
        ], disabled: false
      },
      {
        name: 'End Time', controlName: 'endTime', type: 'select', data: [
          { 'key': '00:00:00', 'value': '00:00:00 AM' },
          { 'key': '01:00:00', 'value': '01:00:00 AM' },
          { 'key': '02:00:00', 'value': '02:00:00 AM' },
          { 'key': '03:00:00', 'value': '03:00:00 AM' },
          { 'key': '04:00:00', 'value': '04:00:00 AM' },
          { 'key': '05:00:00', 'value': '05:00:00 AM' },
          { 'key': '06:00:00', 'value': '06:00:00 AM' },
          { 'key': '07:00:00', 'value': '07:00:00 AM' },
          { 'key': '08:00:00', 'value': '08:00:00 AM' },
          { 'key': '09:00:00', 'value': '09:00:00 AM' },
          { 'key': '10:00:00', 'value': '10:00:00 AM' },
          { 'key': '11:00:00', 'value': '11:00:00 AM' },
          { 'key': '12:00:00', 'value': '12:00:00 PM' },
          { 'key': '13:00:00', 'value': '01:00:00 PM' },
          { 'key': '14:00:00', 'value': '02:00:00 PM' },
          { 'key': '15:00:00', 'value': '03:00:00 PM' },
          { 'key': '16:00:00', 'value': '04:00:00 PM' },
          { 'key': '17:00:00', 'value': '05:00:00 PM' },
          { 'key': '18:00:00', 'value': '06:00:00 PM' },
          { 'key': '19:00:00', 'value': '07:00:00 PM' },
          { 'key': '20:00:00', 'value': '08:00:00 PM' },
          { 'key': '21:00:00', 'value': '09:00:00 PM' },
          { 'key': '22:00:00', 'value': '10:00:00 PM' },
          { 'key': '23:00:00', 'value': '11:00:00 PM' }
        ], disabled: false
      },
      {
        name: 'Hourly Frequency', controlName: 'hourlyFrequency', type: 'select', data: [
          { 'key': '01:00:00', 'value': '01:00:00 Hour' },
          { 'key': '02:00:00', 'value': '02:00:00 Hour' },
          { 'key': '03:00:00', 'value': '03:00:00 Hour' },
          { 'key': '04:00:00', 'value': '04:00:00 Hour' },
          { 'key': '05:00:00', 'value': '05:00:00 Hour' },
          { 'key': '06:00:00', 'value': '06:00:00 Hour' },
          { 'key': '07:00:00', 'value': '07:00:00 Hour' },
          { 'key': '08:00:00', 'value': '08:00:00 Hour' },
          { 'key': '09:00:00', 'value': '09:00:00 Hour' },
          { 'key': '10:00:00', 'value': '10:00:00 Hour' },
          { 'key': '11:00:00', 'value': '11:00:00 Hour' },
          { 'key': '12:00:00', 'value': '12:00:00 Hour' },
          { 'key': '13:00:00', 'value': '13:00:00 Hour' },
          { 'key': '14:00:00', 'value': '14:00:00 Hour' },
          { 'key': '15:00:00', 'value': '15:00:00 Hour' },
          { 'key': '16:00:00', 'value': '16:00:00 Hour' },
          { 'key': '17:00:00', 'value': '17:00:00 Hour' },
          { 'key': '18:00:00', 'value': '18:00:00 Hour' },
          { 'key': '19:00:00', 'value': '19:00:00 Hour' },
          { 'key': '20:00:00', 'value': '20:00:00 Hour' },
          { 'key': '21:00:00', 'value': '21:00:00 Hour' },
          { 'key': '22:00:00', 'value': '22:00:00 Hour' },
          { 'key': '23:00:00', 'value': '23:00:00 Hour' },
          { 'key': '24:00:00', 'value': '24:00:00 Hour' }
        ], disabled: false
      }
    ];
    if (show) {
      this.accordions[4].formControls.splice(9, 0, ...arr);
      // Add controls if not already added
      if (!this.merchantForm.contains('startTime')) {
        this.merchantForm.addControl('startTime', new FormControl({
          value: this.merchantDetails.startTime ? this.merchantDetails.startTime : '',
          disabled: false
        }));
      }

      if (!this.merchantForm.contains('endTime')) {
        this.merchantForm.addControl('endTime', new FormControl({
          value: this.merchantDetails.endTime ? this.merchantDetails.endTime : '',
          disabled: false
        }));
      }

      if (!this.merchantForm.contains('hourlyFrequency')) {
        this.merchantForm.addControl('hourlyFrequency', new FormControl({
          value: this.merchantDetails.hourlyFrequency ? this.merchantDetails.hourlyFrequency : '',
          disabled: false
        }));
      }

    } else {
      arr.map((_: any) => {
        this.removeFormControlsByReporting(_.controlName);
      })

      // Remove controls if not needed
      if (this.merchantForm.contains('startTime')) {
        this.merchantForm.removeControl('startTime');
      }

      if (this.merchantForm.contains('endTime')) {
        this.merchantForm.removeControl('endTime');
      }

      if (this.merchantForm.contains('hourlyFrequency')) {
        this.merchantForm.removeControl('hourlyFrequency');
      }
    }
  }

  statusList: any = [];
  getUserStatus() {
    this._MS.getUserStatus().subscribe(
      {
        next: (data: any) => {
          if (data && data.messageStatus === "SUCCESS") {
            this.statusList = data.payload.map((_: any) => {
              return { key: _, value: _ }
            });
          } else {
            this.statusList = [];
            this.alertService.toastWarringMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || 'Something went wrong!',
            })
          }
        },
        error: err => {
          this.statusList = [];
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          })
        }
      }
    )
  }

  modTypeList: any = [];
  getModType() {
    this._MS.getModType().subscribe(
      {
        next: (data: any) => {
          if (data && data.messageStatus === "SUCCESS") {
            this.modTypeList = data.payload.map((_: any) => {
              return { key: _, value: _ }
            });
          } else {
            this.modTypeList = [];
            this.alertService.toastWarringMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || 'Something went wrong!',
            })
          }
        },
        error: err => {
          this.modTypeList = [];
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          })
        }
      }
    )
  }

  changePanel(eve: any) {
    // this.columnDefs = this.columnDefs;
    // debugger
    // setTimeout(() => {
    //   debugger
    //   this.rowData = this.rowData;
    // }, 50);
  }

  get controlNames() {
    return Object.keys(this.merchantForm.controls);
  }

  get merchantFormControls() {
    return this.merchantForm.controls;
  }

  save() {
    if (this.merchantForm.valid) {
      // if (this.isValidate) {
      // let email: any = localStorage.getItem('email');
      let email : any = environment.adminUser;
      let obj = JSON.parse(JSON.stringify(this.merchantDetails));
      obj = { ...obj, ...{ user: this.merchantForm.getRawValue(), payId: this.payId }, loggedUserEmailId: email };
      this._MS.merchantSave(obj).subscribe(
        {
          next: (data: any) => {
            if (data && data.status === "OK") {
              this.alertService.toastSuccessMessageAlert({
                title: data?.Message || data?.message || data?.respmessage || 'Successfully Save.',
              })
            } else {
              this.alertService.toastWarringMessageAlert({
                title: data?.Message || data?.message || data?.respmessage || 'Something went wrong!',
              })
            }
          },
          error: err => {
            this.alertService.toastErrorMessageAlert({
              title: err?.Message || 'Something went wrong!',
            })
          }
        }
      )
      // } else {
      //   this.alertService.toastWarringMessageAlert({
      //     title: "First Validate the Bank Details.",
      //   })
      // }
    } else {
      if (!this.merchantForm.get('state')?.valid) {
        this.alertService.toastWarringMessageAlert({
          title: "State is required",
        })
      }
      if (!this.isBankValid()) {
        this.alertService.toastWarringMessageAlert({
          title: "Bank Details is required.",
        })
      }
      this.submitted = true;
    }
  }

  // isValidate: boolean = false;
  validateBank() {
    if (this.isBankValid()) {
      let obj: any = {
        name: this.getBankObj().accHolderName,
        bankName: this.getBankObj().bankName,
        accountNo: this.getBankObj().accountNo,
        ifscCode: this.getBankObj().ifscCode
      }
      this._MS.pennyDrop(obj).subscribe({
        next: (data: any) => {
          if (data && data.statusCode === "1000") {
            // this.isValidate = true;
            this.isSplitPayment ? this.saveSplitPayment() : null;
            this.alertService.toastSuccessMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || data?.statusDesc || data?.text || 'Successfully Validated.',
            })
          } else {
            // this.isValidate = false;
            this.alertService.toastWarringMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || data?.statusDesc || data?.text || 'Something went wrong!',
            })
          }
        },
        error: err => {
          // this.isValidate = false;
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          })
        }
      }
      )
    } else {
      // this.alertService.toastWarringMessageAlert({
      //   title: "Bank Details is required is required",
      // })
      this.submitted = true;
    }
  }

  saveSplitPayment() {
    if (this.isBankValid() && this.merchantDetails && this.merchantDetails.emailId) {
      let email: any = localStorage.getItem('email');
      let obj: any = {
        loggedUserEmailId: email,
        bankSettle: {
          productId: this.getBankObj().productId,
          bankName: this.getBankObj().bankName,
          ifscCode: this.getBankObj().ifscCode,
          accountHolderName: this.getBankObj().accHolderName,
          branchName: this.getBankObj().branchName,
          accountNumber: this.getBankObj().accountNo,
          email: this.merchantDetails.emailId
        }
      }
      this._MS.saveSplitPayment(obj).subscribe({
        next: (data: any) => {
          if (data && data.status === "OK") {
            this.fetchSplitPayment();
            this.alertService.toastSuccessMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || data?.statusDesc || data?.text || 'Successfully Saved.',
            })
          } else {
            this.alertService.toastWarringMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || data?.statusDesc || data?.text || 'Something went wrong!',
            })
          }
        },
        error: err => {
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          })
        }
      }
      )
    } else {
      this.submitted = true;
    }
  }

  fetchSplitPayment() {
    if (this.merchantDetails && this.merchantDetails.emailId) {
      this._MS.fetchSplitPayment(this.merchantDetails.emailId).subscribe(
        {
          next: (data: any) => {
            if (data && data.status === "OK") {
              this.rowData = data.payload.bankSettles;
            } else {
              this.rowData = [];
            }
          },
          error: err => {
            this.rowData = [];
            this.alertService.toastErrorMessageAlert({
              title: err?.Message || 'Something went wrong!',
            })
          }
        }
      )
    }
  }

  deleteSplitPayment(bankId: string) {
    let email: any = localStorage.getItem('email');
    this._MS.deleteSplitPayment(bankId, email).subscribe({
      next: (data: any) => {
        if (data && data.status === "OK") {
          this.fetchSplitPayment();
          this.alertService.toastSuccessMessageAlert({
            title: data?.Message || data?.message || data?.respmessage || data?.statusDesc || data?.text || 'Successfully Saved.',
          })
        } else {
          this.alertService.toastWarringMessageAlert({
            title: data?.Message || data?.message || data?.respmessage || data?.statusDesc || data?.text || 'Something went wrong!',
          })
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        })
      }
    })
  }

  getBankObj() {
    let obj: any = {}
    this.accordions[7].formControls.map((_: any) => {
      obj[_.controlName] = this.merchantForm.get(_.controlName)?.value
    })
    return obj;
  }

  isBankValid() {
    let isValid = this.accordions[7].formControls.every((_: any) => this.merchantForm.get(_.controlName)?.valid);
    return isValid;
  }

}
